export default {
  replace: 'replace',
  duplicate: 'duplicate',
};
